module.exports = __webpack_public_path__ + "img/icon_map_63_on_111.96222624.png";